// import { Search2 } from "./icons/Search2";
import { ReviewsRepository } from "@repo/fetch-repository/reviews";
import type { Review as ReviewType } from "@repo/fetch-repository/reviews";
import type {
  ComponentSettingsProps,
  ComponentSettings,
} from "@repo/editor/externalComponents";
import * as t from "@rekajs/types";
import { forwardRef, useEffect, useState } from "react";
import { useRouter } from "next/router";
import type { ErrorType } from "@repo/fetch-repository/factory";
import type { ComponentType } from "@repo/editor/types";
import { Search2 } from "../components/icons/search2";

function ReviewItem(props: ReviewType): React.JSX.Element | null {
  return !Array.isArray(props.file.data) ? (
    <div className="grid grid-cols-2 lg:grid-cols-1 gap-5">
      <img
        alt={props.file.data.alt ?? props.title}
        className="w-full h-full object-cover max-h[224.9px] md:max-h-[300px] lg:max-h-[431px]"
        src={props.file.data.url}
      />
      <div className="flex flex-col justify-end gap-y-2 md:gap-y-3 lg:gap-y-5">
        <div className="flex justify-between items-center">
          <h3 className="font-helvetica rtl:font-doran rtl:font-medium text-[16px] md:text-[20px] lg:text-[32px] font-[100] leading-[1] tracking-[-0.32px] text-left text-[#4c4c4c] uppercase">
            {props.title}
          </h3>
          <div className="w-5 h-5 lg:w-10 lg:h-10">
            <Search2 />
          </div>
        </div>

        <div className="w-[70px] md:w-[100px] lg:w-[150px] h-[1px] bg-[#ff7700]" />
        <p className="rtl:font-doran font-helvetica rtl:font-normal text-[15px] md:text-[23px] lg:text-[30px] font-[300] leading-[1] tracking-[0.3px] text-[#b5b5b5]">
          {props.description}
        </p>
      </div>
    </div>
  ) : null;
}

export const ReviewsListDefinition: ComponentSettingsProps = {};
export type ReviewsListProps = ComponentSettingsProps;

export const ReviewsList = forwardRef<HTMLDivElement, ReviewsListProps>(
  (_, ref) => {
    const router = useRouter();
    const locale = router.locale || "en";
    const [reviews, setReviews] = useState<ReviewType[] | null>(null);
    const [error, setError] = useState<ErrorType | null>(null);
    useEffect(() => {
      const reviewRepository: ReviewsRepository = new ReviewsRepository(locale);
      void reviewRepository.getMany().then((res) => {
        if (res.succeeded && res.data) {
          setReviews(res.data);
        } else {
          setReviews(null);
          setError({
            message: res.errors?.message ?? "Unknown error",
            status: res.errors?.status ?? 500,
          });
        }
      });
    }, [locale]);
    return (
      <>
        {error ? (
          <div className="text-red-500">{error.message}</div>
        ) : (
          <div
            className="flex flex-col gap-y-10 md:gap-y-16 lg:gap-y-28"
            ref={ref}
          >
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-40 lg:gap-y-36 gap-y-11 md:gap-y-20">
              {reviews?.map((review) => (
                <ReviewItem key={review.id} {...review} />
              ))}
            </div>
          </div>
        )}
      </>
    );
  }
) as ComponentType<ReviewsListProps>;

ReviewsList.displayName = "ReviewsList";

export const ReviewsListSettings: ComponentSettings = {
  name: "EReviewsList",
  props: ReviewsListDefinition,
  label: "لیست نظرات",
  widgets: {
    label: "هدر نظرات",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "EReviewsList", external: true }),
      }),
  },
};

ReviewsList.componentSettings = ReviewsListSettings;
